var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfdAdaptiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 83,
    viewBox: "0 0 75 83",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1827_12475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 83
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8888 1.27404C39.1026 -0.336138 35.6686 -0.336139 32.8824 1.27404L4.82881 17.4863C2.04601 19.0944 0.332031 22.0646 0.332031 25.2786L0.332031 57.718C0.332031 60.932 2.04602 63.9022 4.82881 65.5103L32.8824 81.7226C35.6686 83.3327 39.1026 83.3327 41.8888 81.7226L69.9424 65.5103C72.7252 63.9022 74.4392 60.932 74.4392 57.718V25.2786C74.4392 22.0646 72.7252 19.0944 69.9424 17.4863L41.8888 1.27404ZM37.3794 58.8243C47.5113 55.5681 53.8672 40.7187 54.6294 33.0176C51.486 27.2882 42.7572 24.1696 37.3794 24.1697C32.0016 24.1696 23.2729 27.2882 20.1295 33.0176C20.8917 40.7187 27.2476 55.5681 37.3794 58.8243Z",
    fill: "url(#paint0_linear_1827_12475)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1827_12475)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6.26953,
    y: -0.445312,
    width: 81.4311,
    height: 82.731,
    fill: "url(#paint1_linear_1827_12475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6092 36.3961C66.4767 62.8823 46.3994 62.5084 37.3253 58.7972L21.4584 30.2434L9.45703 36.3961V65.988L29.453 82.0108L86.1467 91.478C86.4394 62.0815 84.7417 9.91 75.6092 36.3961Z",
    fill: "url(#paint2_linear_1827_12475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6352 33.0144C48.9776 7.302 21.8926 6.72988 8.64123 9.47197C-4.14808 10.1216 -9.30264 29.0015 -10.2812 38.3602L-4.16492 72.6052L20.2339 74.4585C8.4603 56.2455 15.2402 38.945 20.1459 33.0144L54.6352 33.0144Z",
    fill: "url(#paint3_linear_1827_12475)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1827_12475",
    x1: 37.3856,
    y1: 0.0664063,
    x2: 37.3856,
    y2: 82.9302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7872F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1827_12475",
    x1: 49.9308,
    y1: 12.2998,
    x2: 38.2013,
    y2: 61.5901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054746,
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1827_12475",
    x1: 71.9506,
    y1: 56.2461,
    x2: 12.53,
    y2: 51.4941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1827_12475",
    x1: 6.53836,
    y1: 41.1827,
    x2: 45.1908,
    y2: 21.7777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfdAdaptiveIcon);
export default __webpack_public_path__ + "static/media/NfdAdaptiveIcon.cfa350672f97547bf7b0d3776211e384.svg";
export { ForwardRef as ReactComponent };